import { RandomId, StringHelper } from "@swivl-mono/helpers";
import { NodeData_BrainResult, NodeData_LLM, NodeInterface, NodeType } from "@swivl-mono/types";
import { SelectableOption } from "@swivl-mono/ui";
import React, { useEffect } from "react";

import { TagInput, TagInputType } from "../../../../../Components/TagInput/TagInput";
import { AIModel } from "../../../../../Models/AI/AI.Model";
import VarsModel from "../../../../../Models/Variables/VarsModel.Model";
import TabNodeLayoutData from "../../NodeLayouts/TabNodeLayoutData";
import InspectorFooter from "../../SidePanel/Inspector/components/InspectorFooter";
import InspectorNodeHeader from "../../SidePanel/Inspector/components/InspectorNodeHeader";
import NodePanel from "../NodePanel";

const BrainResultNode = {
  Type: NodeType.BrainResult,

  Empty: function () {
    return {
      id: RandomId(6),
      type: NodeType.BrainResult,
      query: "#*User:LastInput*#",
      intent: "",
      confidence: "",
      promptSlug: "",
      brainLabel: "Sales Agent",
      onCompleteGoto: ""
    } as NodeData_BrainResult;
  },

  PlumbData: function (node: NodeInterface) {
    const brainResultNode = node as NodeData_BrainResult;

    const body = brainResultNode.promptSlug || "";

    return TabNodeLayoutData({
      node: node,
      title: "Brain Result",
      body: body,
      baseWidth: 150,
      bodyHeight: body ? 40 : undefined,
      tabs: [{ id: "onCompleteGoto", source: "onCompleteGoto", target: brainResultNode.onCompleteGoto }]
    });
  },

  InspectorPanel: function BrainResultInspectorPanel(props: any) {
    const prompts = AIModel.useState((s) => s.prompts);

    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      AIModel.loadPrompts();
    }, []);

    return <BrainResultNode.InternalInspectorPanel {...props} prompts={prompts} />;
  },

  InternalInspectorPanel: class BrainResultInternalInspectorPanel extends NodePanel {
    buildPromptDropdownOptions(): SelectableOption[] {
      const prompts = (this.props as any).prompts || [];

      // Separate prompts by type
      const structuredPrompts = prompts.filter((p) => p.type === "structured").sort((a, b) => a.name.localeCompare(b.name));
      const searchPrompts = prompts.filter((p) => p.type === "search").sort((a, b) => a.name.localeCompare(b.name));

      const options: SelectableOption[] = [];

      // Section 1: Structured prompts
      if (structuredPrompts.length > 0) {
        options.push({
          isHeading: true,
          label: "─── Structured ───"
        });

        structuredPrompts.forEach((prompt) => {
          options.push({
            value: prompt.slug,
            label: prompt.name
          });
        });

        if (searchPrompts.length > 0) {
          options.push({ isDivider: true, label: "" });
        }
      }

      // Section 2: Search prompts
      if (searchPrompts.length > 0) {
        options.push({
          isHeading: true,
          label: "─── Search ───"
        });

        searchPrompts.forEach((prompt) => {
          options.push({
            value: prompt.slug,
            label: prompt.name
          });
        });
      }

      return options;
    }

    render() {
      const node = this.props.node as NodeData_BrainResult;
      const promptOptions = this.buildPromptDropdownOptions();

      return (
        <div className="panel BrainResultNodePanel">
          <InspectorNodeHeader title="Brain Result" />

          <div className="form-group">
            <TagInput label="Query" value={node.query} onChange={this.onChange} name="query" type={TagInputType.SingleLine} placeholder="" />
          </div>

          <div className="form-group">
            <TagInput
              label="Intent"
              value={node.intent}
              onChange={this.onChange}
              name="intent"
              type={TagInputType.SingleLine}
              placeholder="Unhandled if empty/null"
            />
          </div>

          <div className="form-group">
            <TagInput
              label="Confidence (Optional)"
              value={node.confidence || ""}
              onChange={this.onChange}
              name="confidence"
              type={TagInputType.SingleLine}
              placeholder=""
            />
          </div>

          <div className="form-group">
            <TagInput
              label="Brain Label"
              value={node.brainLabel || ""}
              onChange={this.onChange}
              name="brainLabel"
              type={TagInputType.SingleLine}
              placeholder="Sales Agent"
            />
          </div>

          <div className="form-group">
            <label>Prompt</label>
            <select
              value={node.promptSlug || ""}
              onChange={(e) => this.onChange(e)}
              name="promptSlug"
              style={{ width: "100%", padding: "8px", marginBottom: "8px" }}
            >
              <option value="">-- Select a prompt --</option>
              {promptOptions.map((option, index) => (
                <option key={option.value || `${option.label}-${index}`} value={option.value} disabled={option.isHeading || option.isDivider}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <InspectorFooter
            deleteNode={this.deleteNode}
            node={this.props.node}
            duplicateNode={this.props.duplicateNode}
            canDuplicate={this.props.canDuplicate}
          />
        </div>
      );
    }
  }
};

export default BrainResultNode;
